<template>
  <v-container class="mt-14">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="7">
        <v-row align-center column justify-center>
          <v-row class="mt-2 mb-2">
            <v-progress-circular v-if="loading === true" indeterminate>
            </v-progress-circular>
          </v-row>

          <company-details v-bind:company="company" v-if="finishedLoading === true" @updateCompany="getCompany"/>
        </v-row>
      </v-col>

      <v-col cols="12" sm="10">
        <documents-list :companyId="company.id" v-if="company !== null" :advancedSearch="{}"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as apiCompanies from '../api/companies.js';
import CompanyDetails from '../components/CompanyDetails';
import DocumentsList from '../components/DocumentsList.vue';

export default {
  name: "CompanyDetailsPage",
  components: {
    CompanyDetails,
    DocumentsList
  },
  data: function () {
    return {
      company: null,
      loading: false,
      finishedLoading: false
    }
  },
  mounted () {
    const id = this.$route.params.id
    this.getCompany(id)
  },
  methods: {
    getCompany(id) {
      this.loading = true

      apiCompanies.getCompany(id, this.$store.getters.token, this.$store.getters.factoringCompanyId)
        .then(response => response.json())
        .then(responseData => {
          this.company = responseData;

          this.loading = false
          this.finishedLoading = true
        })
        .catch(() => {
          this.company = null
          console.log("Greska! Nije nadjena kompanija")

          this.loading = false
        })
    }
  }
}
</script>
